export default "__VITE_ASSET__D2e_WgKk__"